<template>
  <div class="generateItem">
    <div class="generateItem__header">
      <div class="generateItem__header__preview">
        <h1 class="medium-title">Add New Listing</h1>
        <div class="generateItem__header__btn">
          <button class="btn-large secondary btn" @click="true"> Preview </button>
        </div>
      </div>
    </div>
    <div class="generateItem__body">
      <!-- Left Content -->
      <div class="generateItem__body__left">
        <div class="generateItem__body__left__form">
          <div class="generateItem__body__left__form__container">
              <div class="generateItem__body__left__form__container__channel">
                <adx-select-dropdown :label="`Channel *`" :options="channelOption" :value.sync="model.channel_detail"/>
              </div>
          </div>
          <!-- About Listings -->
          <div class="generateItem__body__left__form__container">
            <h1 class="subhead">About Listing</h1>
            <div class="generateItem__body__left__form__container__name">
              <adx-input :label="`Listing Name`" :value.sync="model.listing_name" :validation="['NotEmpty']"/>
            </div>
             <div class="generateItem__body__left__form__container__brand">
               <!-- <div class="generateItem__body__content__fieldset__field">
                <adx-single-search-dropdown :label="`Brand *`" :value.sync="model.brand" :optionsParam="brandOptions"/>
              </div> -->
               <!-- <adx-select-dropdown :label="`Brand`" :options="brandOptions" :value.sync="model.brand" class="dropdown"/> -->
                <div><adx-single-search-dropdown :label="`Brand`" :optionsParam="brandOptions" :class="['dropdown long', !userInputted ? 'warning' : '']" :value.sync="model.brand" :size="'size'"/>
                <p v-if="!userInputted" class="error-message">Please select user owner.</p></div>
            </div>
            <div class="generateItem__body__left__form__container__desc">
              <adx-textarea :label="`Description`" class="textarea"  :value.sync="model.description_about"  :validation="['NotEmpty']"/>
            </div>
              <div class="generateItem__body__left__form__container__pricing">
              <adx-select-dropdown :label="`Pricing Plan`" :options="pricingOption" :value.sync="model.pricingType" class="dropdown"/>
              <adx-input :label="`Price`" :value.sync="model.price" :validation="['NotEmpty']"/>
            </div>
            <div class="generateItem__body__left__form__container__quantity">
              <adx-input :label="`Quantity`" :value.sync="model.quantity" class="dropdown" :validation="['NotEmpty']"/>
              <adx-checkbox :label="`Set As Unlimited`" :value.sync="model.unlimited" :valueLabel="`unlimited`" />
              <adx-checkbox :label="`Out Of Stock`" :value.sync="model.outofstock" :valueLabel="`outoftock`" />
            </div>
          </div>
          <!-- Minimum Purchase -->
          <div class="generateItem__body__left__form__container">
            <h1 class="subhead">Minimum Purchase</h1>
            <div class="generateItem__body__left__form__container__timePeriod ">
              <adx-input :label="`Minimun Plan`" :value.sync="model.minTime"  :validation="['NotEmpty']"/>
              <adx-select-dropdown :options="timeOption" :value.sync="model.MinTimeUnit" class="dropdown"/>
            </div>
            <div class="generateItem__body__left__form__container__timePeriod ">
              <adx-input :label="`Minimum Quantity`" :value.sync="model.minQuantity"  :validation="['NotEmpty']"/>
            </div>
          </div>

          <!-- Lead Time -->
          <div class="generateItem__body__left__form__container">
            <h1 class="subhead">Lead Time</h1>
            <div class="generateItem__body__left__form__container__prePostTime">
              <adx-input :label="`Pre Campaign`" :value.sync="model.preTime" class="dropdown" :icon="`day`" :validation="['NotEmpty']"/>
              <adx-input :label="`Post Campaign`" :value.sync="model.postTime" class="dropdown" :icon="`day`" :validation="['NotEmpty']"/>
            </div>
          </div>
          <!-- Linked Inventory -->
          <div class="generateItem__body__left__form__container">
            <h1 class="subhead">Linked Inventory ( Optional )</h1>
            <div class="generateItem__body__left__form__container__linked">
              <div v-for="(link, index) in model.links" :key="index" class="generateItem__body__left__form__container__linked__detail">
                <div class="top">
                  <div><adx-single-search-dropdown :optionsParam="linkedOptions" :class="['dropdown long', !userInputted ? 'warning' : '']" :value.sync="link.inventory_Listing" :size="'size'" @selected="addLink"/>
                  <p v-if="!userInputted" class="error-message">Please select user owner.</p></div>
                  <div class="icon-wrapper"><i @click="deleteLinkedInventory(model.links, index)" class="icon-deleted"></i></div>
                </div>
              </div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="button">
                <button @click="addLinkedInventory(model.links)" class="new">Add new</button>
              </div>
            </div>
          </div>
          <!-- Item Details -->
          <div v-if="model.channel_detail == 'Bus'">
            <!-- Route Detail -->
            <div class="generateItem__body__left__form__container">
              <h1 class="subhead">Item Detail</h1>
              <div class="generateItem__body__left__form__container__route">
                <adx-select-dropdown :label="`Select Route`" :options="routeTypeOption" :value.sync="model.route" class="dropdown select"/>
              </div>
            </div>
            <!-- image-->
            <div class="generateItem__body__left__form__container">
              <div class="generateItem__body__left__form__container__images">
                <h1 class="subhead">Image</h1>
                <div v-for="(image, index) in model.images" :key="index" class="generateItem__body__left__form__container__images__image">
                  <div class="upload-wrapper">
                    <div class="top">
                      <div class="upload-button">
                        <input type="file" accept="image/*" @change="getFile($event, image)"
                        :name="`fileUpload`+index" :id="`fileUpload`+index" style="display: none;">
                        <label :for="`fileUpload`+index" class="button-input" >Add Image</label>
                      </div>
                      <div v-if="image.url" class="file-image">
                        <img :src="image.url"/>
                      </div>
                      <div class="file-name">
                        <label>{{image.name}}</label>
                        <i v-if="image.name" @click="cancelImage(image)" class="adx-ic_cancel"></i>
                      </div>
                    </div>
                    <div class="bottom">
                      <div>
                        <adx-checkbox :label="`Set as featured image`" :valueLabel.sync="image.featuredImage" :value.sync="image.featuredImage" />
                      </div>
                    </div>
                  </div>
                  <div class="icon-wrapper"><i @click="deleteImages(model.images, index)" class="icon-deleted"></i></div>
                </div>
                <div class="line-wrapper">
                  <hr class="line">
                </div>
                <div class="button">
                  <button @click="addImage(model.images)" class="new">Add new</button>
                </div>
              </div>
            </div>
            <!-- end -->
          </div>
        </div>
      </div>  
      <!-- Right Content -->
      <div class="generateItem__body__right">
        <div class="generateItem__body__right__status__content">
          <h1 class="subhead">Status</h1>
          <div>
            <adx-checkbox :label="`Public`" :value.sync="model.isPublic" :valueLabel="`public`" />
            <adx-checkbox :label="`Active`" :value.sync="model.isActive" :valueLabel="`active`" />
          </div>
        </div>
        <div class="generateItem__body__right__status__content2">
          <h1 class="subhead">Owner</h1>
          <div>
            <adx-single-search-dropdown :optionsParam="userOption" :class="['dropdown', !userInputted ? 'warning' : '']" :value.sync="model.user" :size="'size'"/>
            <p v-if="!userInputted" class="error-message">Please select user owner.</p>
          </div>
        </div>
        <div class="generateItem__body__right__status__content3">
          <h1 class="subhead">Tags ( Optional )</h1>
          <div>
          <adx-input-tag
            :limit='model.limit'
            v-model='model.tagsText'
            :ref="model.dataRef.tagsText"
            :placeholder='model.placeholder'
            :read-only='model.readOnly'
            :validate='model.validate'
            :add-tag-on-blur='model.addTagOnBlur'
          />
          </div>
        </div>
        <div class="button">
        <button class="btn-regular secondary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import SelectDropdown from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Checkbox from '@/components/Form/Checkbox'
import TextArea from '@/components/Form/TextArea'
import Dropdown from '@/components/Form/SelectDropdown'
import InputTag from '@/components/Form/InputTag'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import obj2fd from 'obj2fd'

export default {
  name: 'adx-add-new-device',
  components: {
    'adx-input': Input,
    'adx-select-dropdown': SelectDropdown,
    'adx-dropdown': Dropdown,
    'adx-dropdown-list': ListDropdown,
    'adx-checkbox': Checkbox,
    'adx-textarea': TextArea,
    'adx-input-tag': InputTag,
    'adx-single-search-dropdown': SingleSearchDropdown,
  },
  props: {

  },
  data() {
    return {
      userInputted: true,
      linkedOptions : [
        {
          'id': 0,
          'label': '---- unselect ----',
          'value': ""
        },
      ],
      timeOption : [
        {
          'id': 0,
          'label': 'Day',
          'value': 'day'
        },
        {
          'id': 1,
          'label': 'Week',
          'value': 'week'
        },
                {
          'id': 2,
          'label': 'Month',
          'value': 'month'
        },
        {
          'id': 3,
          'label': 'Quarter',
          'value': 'quarter'
        },
        {
          'id': 4,
          'label': 'Year',
          'value': 'year'
        }
      ],
      quantityOption : [
        {
          'id': 0,
          'label': 'Slot',
          'value': 'slot'
        },
        {
          'id': 1,
          'label': 'Unit',
          'value': 'pack'
        },
      ],
      channelOption:[],
      brandOptions: [],
      routeTypeOption:[],
      size : 'small',
      imageFiles: [],
      model: {
        channel_detail: null,
        brand: null,
        listing_name: null,
        brand: [],
        description_about: null,
        price: null,
        pricingType: null,
        quantity: null,
        unlimited: false,
        outofstock: false,
        minTime: null,
        MinTimeUnit: null,
        minQuantity: null,
        minQuantityUnit: null,
        preTime: null,
        postTime: null,
        inventory_Listing: [],
        routeType: [],
        locations: [],
        description_tags: null,
        featuredImage: false,
        user: null,
        isPublic: false,
        isActive: false,
        user:null,
        readOnly: false,
        addTagOnBlur: false,
        allowDuplicates: false,
        placeholder: "Separate tags with comma",
        tagsText:[],
        tags: [],
        limit: 100,
        validate: "",
        step: 1,
        dataRef: {
          tagsText: 'tagsText'
        },
        route: null,
        links: [
          {
            route_type: null,
          }
        ],
        routes: [
          {
            route_type: null,
            location: null,
          }
        ],
        images: [
          {
            name: null,
            image: null,
            featuredImage: null,
            is_primary: null,
            url: null
          }
        ],
        status: null,
      },
      pricingOption: [
        {
          'id': 0,
          'label': 'Price/Day',
          'value': 'day'
        },
        {
          'id': 1,
          'label': 'Price/Week',
          'value': 'week'
        },
        {
          'id': 2,
          'label': 'Price/Month',
          'value': 'month'
        }
      ],
      userOption: [
        {
          id: 0,
          label: 'winda.haryani@adxasia.co.id',
          value: 'winda.haryani@adxasia.co.id'
        },
        {
          id: 1,
          label: 'hrywinda@adxasia.co.id',
          value: 'hrywinda@adxasia.co.id'
        }
      ],
    }
  },
  computed: {
    
  },
  watch: {
    'model.channel_detail': function (newVal, oldVal){
      if (newVal == 'Bus') {
        this.getRoutes()
      }
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    
  },
  mounted() {
    this.initialLoad()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    addLink(value){
      if (value != "") {
        this.model.inventory_Listing.push(value.item.value)
      } else {
        this.model.inventory_Listing = []
      }
    },
    initialLoad() {
      this.getBrands()
      this.getLinkedInventories()
      this.getChannelNames()
    },
    getRoutes () {
      (async () => {
        const response = await api.get(apiV2.getRoutes, { needToken: false, params: {} })
          if (response.status === 200) {
            let data = response.data
            for (let x of data) {
              this.routeTypeOption.push({'id': x.id, 'label': x.title, 'value': x.id}
              )
            }
          }
      })();
    },
    getBrands () {
      (async () => {
        const response = await api.get(apiV2.getBrands, { needToken: false, params: {} })
          if (response.status === 200) {
            let data = response.data
            for (let x of data) {
              this.brandOptions.push({'id': x.id, 'label': x.title, 'value': x.id}
              )
            }
          }
      })();
    },
    getLinkedInventories () {
      (async () => {
        const response = await api.get(apiV2.genericInventories, { needToken: false, params: {} })
          if (response.status === 200) {
            let data = response.data
            for (let x of data) {
              this.linkedOptions.push({'id': x.id, 'label': x.title, 'value': x.id}
              )
            }
          }
      })();
    },
    getChannelNames () {
      (async () => {
        const response = await api.get(apiV2.newChannelNames, { needToken: false, params: {} })
          if (response.status === 200) {
            let data = response.data
            for (let x of data) {
              this.channelOption.push({'id': x.id, 'label': x.name, 'value': x.name}
              )
            }
          }
      })();
      // this.channelOption.push(
      //   {
      //     'id': 1,
      //     'label': 'Google',
      //     'value': 'Google'
      //   }
      // )
      // this.channelOption.push(
      //   {
      //     'id': 2,
      //     'label': 'Bus',
      //     'value': 'Bus'
      //   }
      // )
    },
   save() {
      (async () => {
        const body = {
          generic: {
            title: this.model.listing_name,
            brandId: this.model.brand,
            channelNameId: this.channelOption.filter(el => el.label == this.model.channel_detail).pop().id,
            description: this.model.description_about,
            pricingPlan: this.model.pricingType,
            price: parseInt(this.model.price),
            quantity: parseInt(this.model.quantity),
            unlimited: this.model.unlimited,
            outOfStock: this.model.outofstock,
            minPeriodPlan: this.model.MinTimeUnit,
            minPeriod: this.model.minTime,
            minQuantity: parseInt(this.model.minQuantity),
            leadPreCampaign: parseInt(this.model.preTime),
            leadPostCampaign: parseInt(this.model.postTime),
            linkedInventories: this.model.inventory_Listing,
            isActive: this.model.isActive,
            isPublic: this.model.isPublic,
            owner: 1,
            tags: this.model.tagsText
          },
          bus: {
            route: this.model.route,
            contents: this.imageFiles,
            // genericId: 2,
          }
        }
        // console.log(body)
        // const response = await api.post(apiV2.newListingBus, body.bus, { needToken: false })

        // const body = 
        // {
        //   title: this.model.listing_name,
        //   brandId: this.model.brand,
        //   channelId: this.model.channel_detail,
        //   description: this.model.description_about,
        //   price: parseInt(this.model.price),
        //   quantity: parseInt(this.model.quantity),
        //   unlimited: this.model.unlimited,
        //   outOfStock: this.model.outofstock,
        //   minPeriod: this.model.minTimePeriod,
        //   minQuantity: parseInt(this.model.minQuantity),
        //   leadPreTime: parseInt(this.model.preTime),
        //   leadPostTime: parseInt(this.model.postTime),
        //   linkedInventories: this.model.inventory_Listing,
        //   isActive: this.model.isActive,
        //   isPublic: this.model.isPublic,
        //   owner: this.model.user,
        //   tags: this.model.tagsText
        // }
        
        // const response = await api.post(apiV2.genericInventories, body, { needToken: false })
        // if (response.status === 200) {
        //   this.$notify({
        //     group: 'saved',
        //     title: 'Success',
        //     text: `Data successfully saved!`,
        //     type: 'success'
        //   });
        // } else {
        //   this.$notify({
        //     group: 'saved',
        //     title: 'Error',
        //     text: response.statusText,
        //     type: 'danger'
        //   });
        // }

        const resGeneric = await api.post(apiV2.genericInventories, body.generic, { needToken: false })
        if (resGeneric.status == 200) {
          let generic = resGeneric.data
          body.bus.genericId = generic.id
          const resBus = await api.post(apiV2.newListingBus, body.bus, { needToken: false })
          if (resBus.status == 200) {
            this.$notify({
              group: 'saved',
              title: 'Success',
              text: `Data successfully saved!`,
              type: 'success'
            });
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: resBus.statusText,
              type: 'danger'
            });
          }
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: resGeneric.statusText,
            type: 'danger'
          });
        }
      })();
    },
     addLinkedInventory(link) {
      link.push(
        {
          pricingType: null,
          location: null,
        }
      )
    },
    addRouteDetail(route) {
      route.push(
        {
          pricingType: null,
          location: null,
        }
      )
    },
    addImage(image) {
      image.push(
        {
          name: null,
          image: null,
          featuredImage: null,
          is_primary: null,
          url: null
        }
      )
    },
    addRevenueShare(revenue) {
      revenue.push(
        {
          user: null,
          role: null,
          percentage: null
        }
      )
    },
    deleteLinkedInventory(link, index) {
      if (link.length > 1) {
        link.splice(index, 1)
        this.model.inventory_Listing.splice(index, 1)
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    deleteRouteDetail(route, index) {
      if (route.length > 1) {
        route.splice(index, 1)
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    deleteImages(image, index) {
      if (image.length > 1) {
        image.splice(index, 1)
        this.imageFiles = this.imageFiles.splice(index, 1)
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    launchFilePicker(){
      this.$refs.fileUpload.click()
    },
    getRefs(index){
      return `fileUpload${index}`
    },
    cancelImage(image) {
      image.name = null
      image.data = null
      image.url = null
    },
    getFile(event, image) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateFile(input.files[0])
        if (!validated_data.is_valid) {
          this.error['avatar'] = validated_data.message
        } else {
          reader.onload = (e) => {
            image.url = e.target.result;
          }
          reader.readAsDataURL(input.files[0]);
          image.name = input.files[0].name;
          image.image = input.files[0];

          (async () => {
            var data = new FormData();

            let object = {
                file: input.files[0]
            }

            data = obj2fd(object)
            const response = await api.post(apiV2.uploadBusImage, data, { needToken: false })
            if (response.status == 200) {
              let content =  response.data.content
              this.imageFiles.push(content.id)
            }
          })();
        }
      }
    },
    validateFile(file) {
      let maxSize = 2000000; // 2 MB
      let data = { is_valid: true }
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
        }
      } else {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File too large.`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 100) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 100 character'
        return data
      }

      if (filename.includes('/')) {
        data.is_valid = false
        data.message = 'File name has forbidden character'
        return data
      }
      return data
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.generateItem {
  &__body {
    &__left {
      &__form {
        &__size {
          .selectDropdown {
            input {
              padding-top: 0;
            }

            .popup{
              &__input{
                max-width: 100%;
                margin-left: 48px;
              }
            }
          }
        }

        &__container{
          &__quantity, &__images__image {
            .checkbox {
              input{
                min-height: 0;
              }
            }
          }
        }
      }
      input {
        min-height: 60px;
      }
    }

    &__right__status__content {
      .checkbox {
        input{
          min-height: 0;
        }
      }
    }
  }

  

  .selectDropdown {
    .select {
      input {
        min-height: 62px;
      }
    }
  }

  .btn-regular {
    min-width: 32px;
    height: 45px;

    &.teal {
      background-color: $white;
      border: solid 1px $pale-grey;
      color: unset;
    }
  }
}
</style>
